import { Navigate, Route, Routes } from 'react-router-dom'
import { ProtectedPortal } from './components/ProtectedPortal'
import { InitializePage } from './pages/InitializePage'
import { LandingPage } from './pages/LandingPage'
import { LoginPage } from './pages/LoginPage'
import { MemberPage } from './pages/MemberPage'
import { PortalPage } from './pages/PortalPage'
import { SharedRecordPage } from './pages/SharedRecordPage'
import { VerifyEmailPage } from './pages/VerifyEmailPage'
import { AcceptInvitePage } from './pages/AcceptInvitePage'
import { ForgotPasswordPage } from './pages/ForgotPasswordPage'
import { ResetPasswordPage } from './pages/ResetPasswordPage'
import { SignUpPage } from './pages/SignUpPage'
import { StorePage } from './pages/StorePage'

export default function App() {
  return <Routes>
    <Route path="/" element={<LandingPage />} />
    <Route path="/store" element={<StorePage />} />
    <Route path="/case/:caseId" element={<Navigate to="/" replace />} />
    <Route path="/share/:token" element={<SharedRecordPage />} />
    <Route path="/verify-email/:token" element={<VerifyEmailPage />} />
    <Route path="/accept-invite/:token" element={<AcceptInvitePage />} />
    <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
    <Route path="/member/signup" element={<SignUpPage />} />
    <Route path="/member/forgot-password" element={<ForgotPasswordPage />} />
    <Route path="/member/login" element={<LoginPage role="member" />} />
    <Route path="/member/*" element={<ProtectedPortal role="member"><MemberPage /></ProtectedPortal>} />
    <Route path="/super-admin/login" element={<LoginPage role="super_admin" />} />
    <Route path="/super-admin/initialize" element={<InitializePage />} />
    <Route path="/hospital-admin/login" element={<LoginPage role="hospital_admin" />} />
    <Route path="/super-admin/*" element={<ProtectedPortal role="super_admin"><PortalPage kind="super" /></ProtectedPortal>} />
    <Route path="/hospital-admin/*" element={<ProtectedPortal role="hospital_admin"><PortalPage kind="hospital" /></ProtectedPortal>} />
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes>
}
